<!-- <div *ngFor="let role of userRoles">
<ng-container *ngIf="role === 'ADMINISTRATEUR'">
  <p>Gestion des utilisateurs</p>
  <div>
    <button (click)="ManageKeycloakUser()">Utilisateurs </button>
  </div>
</ng-container>
</div> -->


<h2>{{'USER_KEYCLOAK.TITRE_PROFILE' | translate}}</h2>
<p>{{'USER_KEYCLOAK.NOM_UTILISATEUR' | translate}} : {{userProfile?.firstName}} {{userProfile?.lastName}}</p>
<p>{{'USER_KEYCLOAK.UTILISATEUR_EMAIL' | translate}} : {{userProfile?.email}}</p>


<h2>{{'USER_KEYCLOAK.ROLE_UTILISATEUR' | translate}}</h2>
<ul class="scroll-list">
  @for (role of userRoles; track role) {
    <li>{{role}}</li>
  }
</ul>

<!-- <h2>Jeton d'accès de l'utilisateur</h2>
<p>{{accessToken}}</p>
-->


